export interface TradingAccountActivityPerGroupingDto {
  dateFrom: string
  dateTo: string
  login: string | null
  count: number
}

export enum TradingAccountActivityPerGroupingDtoKey {
  dateFrom = 'dateFrom',
  dateTo = 'dateTo',
  login = 'login',
  count = 'count',
}
